import { CheckCircle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function PaymentSelector({
  methods,
  selectedCode,
  showHeader = true,
  onChange,
}) {
  return (
    <Box data-testid="payment-section">
      {showHeader && (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.25 }}>
          <Box>
            <Typography sx={{ fontSize: 12, fontWeight: 900, color: "#2C3087", letterSpacing: ".08em" }}>
              3 · MEDIO DE PAGO
            </Typography>
            <Typography sx={{ fontSize: 14, color: "#64748B" }}>
              {methods.length ? "Elegí cómo cobra el vendedor" : "Sin medios disponibles"}
            </Typography>
          </Box>
          {Boolean(selectedCode) && <CheckCircle sx={{ color: "#2C9A83" }} />}
        </Box>
      )}
      {!methods.length && (
        <Box sx={{ p: 1.5, borderRadius: "12px", bgcolor: "#FFF7E6", border: "1px solid #F5DFB0" }}>
          <Typography sx={{ fontSize: 12.5, color: "#80520D" }}>
            Todavía no hay medios de pago habilitados para el evento. El cobro se habilita
            a medida que cada medio queda implementado y verificado en el backend.
          </Typography>
        </Box>
      )}
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(4, minmax(0, 1fr))" }, gap: 0.8 }}>
        {methods.map((method) => {
          const selected = selectedCode === method.code;
          return (
            <Box
              key={method.code}
              component="button"
              type="button"
              data-testid={`payment-${method.code}`}
              aria-pressed={selected}
              onClick={() => onChange(method.code)}
              sx={{
                position: "relative",
                border: selected ? "2px solid #2C3087" : "1px solid #DCE3EC",
                bgcolor: selected ? "#F3F2FF" : "#fff",
                color: selected ? "#2C3087" : "#475569",
                borderRadius: "12px",
                py: 1,
                px: 0.5,
                minHeight: 65,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 0.4,
                fontFamily: "inherit",
                transition: "all 130ms ease",
                "&:hover": { borderColor: "#2C3087", bgcolor: "#F8F7FF" },
                "&:focus-visible": { outline: "3px solid rgba(44, 48, 135, 0.24)" },
              }}
            >
              {method.recommended && (
                <Box
                  component="span"
                  sx={{
                    position: "absolute",
                    top: 5,
                    right: 5,
                    px: 0.75,
                    py: 0.2,
                    borderRadius: "999px",
                    bgcolor: "#E6F6EF",
                    color: "#187A5A",
                    fontSize: 8.5,
                    lineHeight: 1.25,
                    fontWeight: 900,
                    letterSpacing: ".04em",
                    textTransform: "uppercase",
                  }}
                >
                  Recomendado
                </Box>
              )}
              <Box component="span" className="material-icons-round" sx={{ fontSize: 22 }}>
                {method.icon}
              </Box>
              <Typography component="span" sx={{ fontSize: 11, lineHeight: 1, fontWeight: 800 }}>
                {method.label}
              </Typography>
            </Box>
          );
        })}
      </Box>

    </Box>
  );
}

PaymentSelector.propTypes = {
  methods: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedCode: PropTypes.string.isRequired,
  showHeader: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};
